var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBsApprovals = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 28,
  viewBox: "0 0 24 28",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.088 21h19.824c1.154 0 2.088.895 2.088 2 0 1.112-.935 2-2.088 2H2.088C.934 25 0 24.105 0 23c0-1.112.935-2 2.088-2M14.502 0A2.5 2.5 0 0 1 17 2.505v6.662s-2 0-2 5.833v5H9v-5c0-5.833-2-5.833-2-5.833V2.505A2.503 2.503 0 0 1 9.498 0zM23 26v2H1v-2z"
})));
export default SvgBsApprovals;